import{pathOr as r}from"ramda";var o=function(o){return o?"object"==typeof o?r("",["name"],o):o:""};export{o as getPackageValueForEEC};
